import { Component, Input, OnInit } from '@angular/core';

import { Topic } from '../../../models/topic';
import { IFile } from 'app/models/file';
import { FileType } from 'app/models/file-type.enum';

@Component({
  selector: 'app-topic-item',
  templateUrl: './topic-item.component.html',
  styleUrls: ['./topic-item.component.scss']
})
export class TopicItemComponent implements OnInit {
  @Input() topic: Topic;

  constructor() {}

  ngOnInit() {}

  get thumbnailFile(): IFile | null {
    if (!this.topic?.files?.length) return null;

    // If admin explicitly chose a thumbnail, use that
    if (this.topic.thumbnailFileId) {
      const chosen = this.topic.files.find(f => f.id === this.topic.thumbnailFileId);
      if (chosen) return chosen;
    }

    // Auto-fallback: first video, then first image (case-insensitive)
    return this.topic.files.find(f => (f.contentType || '').toUpperCase() === FileType.Video || (f.source || '').toUpperCase() === 'VIDEO')
        || this.topic.files.find(f => (f.contentType || '').toUpperCase() === FileType.Img || (f.source || '').toUpperCase() === 'IMG')
        || null;
  }

  get isVideo(): boolean {
    const ct = (this.thumbnailFile?.contentType || '').toUpperCase();
    const src = (this.thumbnailFile?.source || '').toUpperCase();
    return ct === FileType.Video || src === 'VIDEO';
  }
}
